module.exports = __webpack_public_path__ + "img/oven-fried-okra.befee5d6.jpg";